<!-- 表具实时数据 -->
<template>
  <div>
    <!-- 查询区域 -->
    <!-- <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="表编号">
              <j-input placeholder="表编号模糊查询" v-model="queryParam.meterId"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="用户编号">
              <j-input placeholder="用户编号模糊查询" v-model="queryParam.userId"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="用户姓名">
              <j-input placeholder="用户姓名模糊查询" v-model="queryParam.userName"></j-input>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="用户地址">
                <j-input placeholder="用户地址模糊查询" v-model="queryParam.userAddr"></j-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="册号">
                <a-input placeholder="请输入册号" v-model="queryParam.mtVolumeNo"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="上报方式">
                <a-select
                  mode="multiple"
                  style="width: 100%"
                  placeholder="请选择上报方式"
                  v-model="meterUpWay"
                  @change="handleChangeMeterUpWay"
                >
                  <a-select-option v-for="(item,key) in SendWayObj" :value="key" :key="key">
                    {{item}}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="阀门是否故障">
                <a-select
                  v-model="queryParam.meterValveFault"
                  placeholder="请选择阀门是否故障"
                  >
                  <a-select-option :value="0">
                    正常
                  </a-select-option>
                  <a-select-option :value="1">
                    故障
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="阀门状态">
                <a-select
                  mode="multiple"
                  style="width: 100%"
                  placeholder="请选择阀门状态"
                  v-model="meterValveStatus"
                  @change="handleChangeMeterValveStatus"
                >
                  <a-select-option v-for="(item,key) in Mn100FkStatusObj" :value="key" :key="key">
                    {{item}}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="电池状态">
                <a-select
                  v-model="queryParam.meterBatteryStatus"
                  placeholder="请输入电池状态"
                  >
                  <a-select-option :value="0">
                    正常
                  </a-select-option>
                  <a-select-option :value="1">
                    欠压
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="有无磁干扰">
                <a-select placeholder="请输入有无磁干扰" v-model="queryParam.meterMagentic">
                  <a-select-option :value="0">
                    正常
                  </a-select-option>
                  <a-select-option :value="1">
                    有
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="表类型">
                <j-dict-select-tag v-model="queryParam.meterType" placeholder="请表类型" dictCode="meter_type" />
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="表口径">
                <a-select
                  mode="multiple"
                  v-model="meterCaliber"
                  placeholder="请选择表口径"
                  @change="handleChangeMeterCaliber"
                  >
                  <a-select-option v-for="data in userCaliberList" :key="data.id" :value="data.mtCaliber">
                    DN{{data.mtCaliber}}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            
            <a-col :span="8">
              <a-form-model-item label="上报时间">
                <a-range-picker
                  v-model="date"
                  :placeholder="['查询起始时间', '查询结束时间']"
                  format="YYYY-MM-DD"
                  @change="onDateRangeChange"
                />
              </a-form-model-item>
            </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div> -->
    <!-- table区域-begin -->
    <div class="table-fixed">
      <a-table
        ref="table"
        size="middle"
        :scroll="{ x: true }"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :components="drag(columns)"
        @change="handleTableChange">
        <a-icon slot="filterIcon" type='down' :style="{ fontSize:'12px',color: '#108ee9'}" />
        <span slot="action" slot-scope="text, record" class="action">
          <a @click="handleDetail(record)">{{ $t('详情') }}</a>
        </span>
      </a-table>
    </div>
    <meter-elef-up-data-modal ref="elefUpDataModal" @ok="modalFormOk"></meter-elef-up-data-modal>
    <meter-us-up-data-modal ref="usModalForm" @ok="modalFormOk"></meter-us-up-data-modal>
    <meter-up-data-modal ref="modalForm" @ok="modalFormOk" :id="id"></meter-up-data-modal>
  </div>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {AreaChoosetMixin} from '@/mixins/AreaChooseMixin'
  import MeterUpDataModal from '@/views/InternetDeviceManagement/modules/MeterUpDataModal.vue'
  import MeterUsUpDataModal from '@/views/InternetDeviceManagement/modules/MeterUsUpDataModal'
  import MeterElefUpDataModal from '@/views/InternetDeviceManagement/modules/MeterElefUpDataModal'
  import { getAction,downFile } from '@/api/manage'
  import {isUndefined} from'@/utils/validate'
  import { listSize,filterObj } from '@/utils/util'
  import configService from '@/utils/service/config.service'
  import Vue from 'vue'
  import {netTypeObj,Mn100FkStatusObj,SendWayObj} from '@/utils/constants/protocolConstant'
  import {meterTypeObj} from '@/utils/constants/commonConstant'
  import JInput from '@/components/jeecg/JInput'
  import TableDragResize  from '@/mixins/TableDragResize'


  export default {
    name: 'MeterUpDataList',
    mixins:[JeecgListMixin, mixinDevice,AreaChoosetMixin,TableDragResize],
    components: {
      MeterUpDataModal,
      MeterUsUpDataModal,
      MeterElefUpDataModal,
      JInput,
    },
    props:{
      id:{
        type: String,
        default: ''
      }
    },
    data () {
      return {
        description: 'meter_up_data管理页面',
        collapsed: false,
        netTypeObj,
        Mn100FkStatusObj,
        SendWayObj,
        meterTypeObj,
       //表头
        columns:[],
        //列设置
        settingColumns:[],
        url: {
          list: "/jeecg-charge/meter/meterUpData/list",
          userTypeList:"/jeecg-charge/meter/meterType/list",  //表类型请求地址  
          userCaliberList:"/jeecg-charge/meter/meterCaliber/list",  //表口径请求地址
        },
        dictOptions:{},
        userTypeList:[],  //表类型
        userCaliberList:[],  // 表口径
        meterUpWay: [],
        meterValveStatus: [],
        meterCaliber: []
      }
    },
    watch:{
      id(val){
        if(val){
          this.loadData();
        }
      }
    },
    created() {
      this.initColumns();
      this.queryUserCaliberList();
      this.queryUserTypeList();
    },
    // i18n：表头使用 computed 以响应语言切换
    computed: {
      defColumns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            },
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon'
            }
          },{
            title: this.$t('用户编号'),
            align:"center",
            dataIndex:'userId',
            width:150,
            ellipsis: true
          },{
            title: this.$t('用户姓名'),
            align:"center",
            dataIndex:'userName',
            width:150,
            ellipsis: true
          },{
            title: this.$t('用户地址'),
            align:"center",
            dataIndex:'userAddr',
            width:200,
            ellipsis: true,
            customRender: (t,r,index) => {
              if(r.userAreaName){
                let i = r.userAreaName.indexOf('-');
                return r.userAreaName.slice(i+1,r.userAreaName.length)+'-'+t;
              }else{
                return t
              }
            },
          },{
            title: this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId',
            width:150,
            ellipsis: true
          },{
            title: this.$t('册号'),
            align:"center",
            dataIndex: 'mtVolumeNo',
            width: 150
          },{
            title: this.$t('表类型'),
            align:"center",
            dataIndex: 'mtName',
            width:100,
            ellipsis: true
          },{
            title: this.$t('表端时间'),
            align:"center",
            dataIndex: 'meterTime',
            width:150,
            ellipsis: true
          },{
            title: this.$t('上报时间'),
            align:"center",
            dataIndex: 'sysTime',
            width:150,
            ellipsis: true
          },{
            title: this.$t('阀门是否故障'),
            align:"center",
            dataIndex: 'meterValveFault',
            customRender: (t,r,index) => {
              let data = {"0": this.$t("正常"),"1":this.$t("故障"),"null": this.$t("正常")}
              if(isUndefined(data[t])) {
                return this.$t('其他')
              }
              return data[t]
            },
            width:100,
            ellipsis: true
          },{
            title: this.$t('阀门状态'),
            align:"center",
            dataIndex:'meterValveStatus',
            customRender: (t,r,index) => {
              let data = Mn100FkStatusObj;
              if(isUndefined(data[t])) {
                return this.$t('未知');
              }
              return this.$t(data[t])
            },
            width:100,
            ellipsis: true
          },{
            title: this.$t('阀控状态'),
            align:"center",
            dataIndex: 'meterHasValveControll',
            customRender: (t,r,index) => {
              let data = {"0": this.$t("无阀控"),"1":this.$t("有阀控")}
              if(isUndefined(data[t])) {
                return "--"
              }
              return data[t]
            },
            width:100,
            ellipsis: true
          },
          {
            title: this.$t('上报累计流量(m³)'),
            align:"center",
            dataIndex: 'meterTotalUse',
            width:150,
            ellipsis: true
          },
          {
            title: this.$t('电池电压(V)'),
            align:"center",
            dataIndex: 'meterBatteryVoltage',
            width:100,
            ellipsis: true
          },{
            title: this.$t('上报方式'),
            align:"center",
            dataIndex: 'meterUpWay',
            customRender: (t,r,index) => {
              let data = SendWayObj;
              if(isUndefined(data[t])) {
                return this.$t('其他')
              }
              return this.$t(data[t])
            },
            width:100,
            ellipsis: true
          },
          {
            title: this.$t('运营商'),
            align:"center",
            dataIndex: 'meterIotType',
            customRender: (t,r,index) => {
              let data = netTypeObj
              if(isUndefined(data[t])) {
                return this.$t('其他')
              }
              return this.$t(data[t])
            },
            width:100,
            ellipsis: true
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:100,
            scopedSlots: { customRender: 'action' }
          }
        ]
      }
    },
    methods: {
      loadData(){
        var params = this.getQueryParams();//查询条件
        params.userId = this.id;
        getAction(this.url.list,params).then(res=>{
          if(res.success){
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
          }
        })
      },
      handleChangeMeterUpWay(value) {
        this.queryParam.meterUpWay= value +"";
      },
      handleChangeMeterValveStatus(value) {
        this.queryParam.meterValveStatus= value +"";
      },
      handleChangeMeterCaliber(value) {
        this.queryParam.meterCaliber= value +"";
      },
      queryUserTypeList() {   //表类型请求
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        getAction(this.url.userTypeList, params).then((res) => {
          if(res.success){
            this.userTypeList = res.result.records;
            console.log(this.userTypeList);
          }
        }) 
      },
      initColumns(){
        //权限过滤（列权限控制时打开，修改第二个参数为授权码前缀）
        //this.defColumns = colAuthFilter(this.defColumns,'testdemo:');
        var key = this.$route.name+":colsettings";
        let colSettings= Vue.ls.get(key);
        if(colSettings===null||colSettings==undefined){
          let allSettingColumns = [];
          this.defColumns.forEach(function (item,i,array ) {
            allSettingColumns.push(item.dataIndex);
          })
          this.settingColumns = allSettingColumns;
          this.columns = this.defColumns;
        }else{
          this.settingColumns = colSettings;
          const cols = this.defColumns.filter(item => {
            if(item.key =='rowIndex'|| item.dataIndex=='action'){
              return true;
            }
            if (colSettings.includes(item.dataIndex)) {
              return true;
            }
            return false;
          })
          this.columns =  cols;
        }
      },
      queryUserCaliberList() {   //表口径请求
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        params.column = 'mtCaliber';
        params.order = 'asc';
        getAction(this.url.userCaliberList, params).then((res) => {
          if(res.success){
            this.userCaliberList = res.result.records;
          }
        }) 
      },
      searchReset() {
        this.queryParam = {}
        this.resetAareaData()
        this.date = []
        this.meterUpWay = []
        this.meterCaliber = []
        this.meterValveStatus = []
        this.loadData();
      },
      handleDetail:function(record){debugger
        console.log(record)
        if(record.meterType == '15') {
          this.$refs.usModalForm.edit(record);
          this.$refs.usModalForm.title=this.$t('详情');
          this.$refs.usModalForm.disableSubmit = true;
        }else if(record.meterType == 'Y14-4G'){
          // 迅尔电磁流量计
          this.$refs.elefUpDataModal.edit(record);
          this.$refs.elefUpDataModal.title=this.$t('详情');
          this.$refs.elefUpDataModal.disableSubmit = true;
        }else{
          this.$refs.modalForm.edit(record);
          this.$refs.modalForm.title=this.$t('详情');
          this.$refs.modalForm.disableSubmit = true;
        }
      },
    }
  }
</script>
<style scoped>
  .my-area-select-tree /deep/ li .ant-tree-node-content-wrapper{
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
  }
</style>